import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { tokens } from '@fluentui-copilot/tokens';
import type { ChatInputEntitySlots, ChatInputEntityState } from './ChatInputEntity.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const chatInputEntityClassNames: SlotClassNames<ChatInputEntitySlots> = {
  root: 'fai-ChatInputEntity',
  sensitivity: 'fai-ChatInputEntity__sensitivity',
  text: 'fai-ChatInputEntity__text',
};

/**
 * Styles for the root slot
 */
const useStyles = makeStyles({
  root: {},

  text: {
    color: tokens.colorBrandForeground1,
  },

  href: {
    color: tokens.colorBrandForegroundLink,

    ':hover': {
      textDecorationLine: 'underline',
      color: tokens.colorBrandForegroundLinkHover,
    },

    ':active': {
      textDecorationLine: 'underline',
      color: tokens.colorBrandForegroundLinkPressed,
    },
  },
  sensitivity: {
    paddingLeft: tokens.spacingHorizontalXXS,
  },
});

/**
 * Apply styling to the ChatInputEntity slots based on the state
 */
export const useChatInputEntityStyles_unstable = (state: ChatInputEntityState): ChatInputEntityState => {
  'use no memo';

  const styles = useStyles();

  state.root.className = mergeClasses(chatInputEntityClassNames.root, styles.root, state.root.className);

  if (state.text) {
    state.text.className = mergeClasses(
      chatInputEntityClassNames.text,
      styles.text,
      state.text.as === 'a' && styles.href,
      state.text.className,
    );
  }

  if (state.sensitivity) {
    state.sensitivity.className = mergeClasses(
      chatInputEntityClassNames.sensitivity,
      styles.sensitivity,
      state.sensitivity.className,
    );
  }

  return state;
};
